import { useDispatch } from 'react-redux';
import { kebabCase } from 'lodash';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { updateLandingPage } from '../flows/updateLandingPage';

export const useHandlePublish = () => {
    const dispatch = useDispatch();
    const { accountName } = useAccount();

    const updateLandingPageWrapper = landingPage =>
        dispatch(
            updateLandingPage({
                accountName,
                landingPageId: landingPage.id,
                slug: kebabCase(landingPage.title),
                isActive: true,
                activeVersionNumber: landingPage.versionNumber, // BE don't use this field on Unpublish
            })
        );

    return updateLandingPageWrapper;
};
